module.exports = __webpack_public_path__ + "img/icon_circle_check.ae637b9a.svg";